import { Injectable } from '@angular/core';

// Common Libs
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';

// Model
import { Disclaimer } from '../models/disclaimer';

@Injectable()
export class DisclaimerService {

  constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

  getDisclaimer(event_id){
    if(this.utilityService.isLogged()){
      let data: AngularFireObject<Disclaimer> = this.db.object(`${Constants.EVENT_URL}/${event_id}/${Constants.PREDERENCES_URL}/${Constants.PREF_DISCLAIMER}`)
      return data.valueChanges();
    }
    return null;
  }
  updateDisclaimer(event_id, disclaimer:Disclaimer){

    console.log("Saving Disclaimer", disclaimer);
    let DB_PATH = `${Constants.EVENT_URL}/${event_id}${Constants.PREDERENCES_URL}${Constants.PREF_DISCLAIMER}`;
    return this.db.object(DB_PATH).set(Object.assign({},disclaimer))
    .then(d=>console.log("Database Updated", DB_PATH  ))
    .catch(e=>console.error(e));

  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/disclaimer.service.ts